import TodayCalendar from './dash/TodayCalendar.jsx';
import TodayMITs from './dash/TodayMITs.jsx';
import Inbox from './dash/Inbox.jsx';
import RecentWins from './dash/RecentWins.jsx';
import CondensedStreaks from './dash/CondensedStreaks.jsx';

export default function FullDash() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      {/* Left column */}
      <div className="space-y-4">
        <TodayCalendar />
        <TodayMITs />
      </div>

      {/* Right column */}
      <div className="space-y-4">
        <Inbox />
        <RecentWins />
        <CondensedStreaks />
      </div>
    </div>
  );
}
